<template>
  <div class="rt-header-button-group">
    <slot />
    <div v-if="showMore" class="button-group-more">
      <el-popover
        ref="popover"
        trigger="hover"
        popper-class="rtElPopover"
        @show="moveBtns"
      >
        <rt-button
          slot="reference"
          class="rt-button-more"
          icon-name="rt-base-more"
        ></rt-button>
      </el-popover>
    </div>
  </div>
</template>

<script>
import RtButton from '../../button/rtButton';
export default {
  name: 'RtHeaderButtonGroup',
  components: {
    RtButton
  },
  props: {
    maxBtns: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      showMore: false,
      btns: [],
      movedBtns: [],
      moved: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.$slots.default) {
        this.btns = this.$slots.default.filter(item => {
          return item.tag;
        });
      }
      if (this.btns.length > this.maxBtns) {
        this.showMore = true;
        this.removeBtns();
      }
    },
    removeBtns() {
      let movedBtns = [];
      this.btns.forEach((item, index) => {
        if (index >= this.maxBtns - 1) {
          movedBtns.push(item.elm);
          this.$el.removeChild(item.elm);
        }
      });
      this.movedBtns = movedBtns.slice();
    },
    moveBtns() {
      if (this.moved) return;
      let divWrapper = document.createElement('div');
      divWrapper.classList.add('rt-button-group-popper-wrapper');
      this.movedBtns.forEach(item => {
        divWrapper.appendChild(item);
      });
      this.$refs.popover.$refs.popper.appendChild(divWrapper);
      this.moved = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtHeaderButtonGroup.vue?3490fde0